var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcGooglePlay24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-google_play-24_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M11.294 11.445 1.232 21.99v.008a2.736 2.736 0 0 0 4.008 1.615l.032-.02 11.325-6.452z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M21.474 9.652h-.01l-4.89-2.798-5.509 4.832 5.53 5.459 4.862-2.771a2.67 2.67 0 0 0 .017-4.722"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M1.23 1.979a2.6 2.6 0 0 0-.092.69v18.635c.002.232.033.465.092.69L11.64 11.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "m11.369 11.987 5.206-5.14L5.263.37a2.75 2.75 0 0 0-1.404-.383 2.714 2.714 0 0 0-2.626 1.992z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-google_play-24_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgIcGooglePlay24;